export default {
    props: {
        attributes: {
            type: Object,
            kComposite: 'attributes'
        }, 
        columns: Array,
        command: {
            type: Array,
            kComposite: 'command'
        },         Editor: {
            type: Function,
            kComposite: 'editor'
        }, 
        encoded: {
            type: Boolean,
            kComposite: 'encoded'
        }, 
        expandable: {
            type: Boolean,
            kComposite: 'expandable'
        }, 
        field: {
            type: String,
            kComposite: 'field'
        }, 
        filterable: {
            type: Boolean,
            kComposite: 'filterable'
        }, 
        filterableUi: {
            type: String | Function,
            kComposite: 'filterable.ui'
        }, 
        footerTemplate: {
            type: String | Function,
            kComposite: 'footerTemplate'
        }, 
        format: {
            type: String,
            kComposite: 'format'
        }, 
        headerAttributes: {
            type: Object,
            kComposite: 'headerAttributes'
        }, 
        headerTemplate: {
            type: String | Function,
            kComposite: 'headerTemplate'
        }, 
        minScreenWidth: {
            type: Number,
            kComposite: 'minScreenWidth'
        }, 
        sortable: {
            type: Boolean,
            kComposite: 'sortable'
        }, 
        sortableCompare: {
            type: Function,
            kComposite: 'sortable.compare'
        }, 
        template: {
            type: String | Function,
            kComposite: 'template'
        }, 
        title: {
            type: String,
            kComposite: 'title'
        }, 
        width: {
            type: String | Number,
            kComposite: 'width'
        }, 
        hidden: {
            type: Boolean,
            kComposite: 'hidden'
        }, 
        menu: {
            type: Boolean,
            kComposite: 'menu'
        }, 
        locked: {
            type: Boolean,
            kComposite: 'locked'
        }, 
        lockable: {
            type: Boolean,
            kComposite: 'lockable'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treelist-vue-wrapper/src/KendoTreeListColumn/Columns.js